import { render, staticRenderFns } from "./ApiOrderAllocation.vue?vue&type=template&id=683a4ff3&scoped=true"
import script from "./ApiOrderAllocation.vue?vue&type=script&lang=js"
export * from "./ApiOrderAllocation.vue?vue&type=script&lang=js"
import style0 from "./ApiOrderAllocation.vue?vue&type=style&index=0&id=683a4ff3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683a4ff3",
  null
  
)

export default component.exports